import IGroup from "../models/IGroup";
import { fetchSecureData } from "../utils";

export const getUserGroups = async (accessToken: string, userId: number) => {
  try {
    const data = await fetchSecureData(
      "GET",
      `/api/Group/GetGroupsForUserId?userId=${userId}`,
      accessToken
    );
    const userGroups = ((await data.json()) as any).value as IGroup[];
    if (userGroups !== undefined) {
      return userGroups;
    } else {
      return [] as IGroup[];
    }
  } catch (err) {
    // tslint:disable-next-line:no-console
    console.log(
      `Fetch error for /api/Group/GetGroupsForUserId?userId=${userId}`,
      err
    );
  }
  return [] as IGroup[];
};

export default getUserGroups;
